import { gql } from "@apollo/client";

export const SOLICITAR_JUSTIFICACION = gql`
mutation SolicitarJustificacion($input: JustificacionCondicionalInput!) {
    solicitarJustificacion(input: $input) {
        idJustificacion
    }
}`;